const formatCpf = cpf =>
  cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')

const formatCnpj = cnpj =>
  cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')

export default str => {
  if (!str) return '-'
  str = str.replace(/D/g, '')
  if (str.length <= 11) return formatCpf(str)

  return formatCnpj(str)
}
